import { ShieldCheck, AlertTriangle } from "lucide-react";
import Reveal from "./Reveal";
import { GUIDE_FACTORS, GUIDE_STEPS, INVESTMENT_DISCLAIMER } from "@/data/content";

export default function InvestmentGuide() {
  return (
    <section id="investment-guide" className="py-24 lg:py-32 bg-gold-light" data-testid="investment-guide-section">
      <div className="container-luxe">
        <div className="max-w-3xl">
          <Reveal>
            <p className="eyebrow mb-4">Investment Guide</p>
            <h2 className="font-serif font-semibold text-navy text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
              Why Are Investors Looking at Dholera?
            </h2>
            <p className="mt-5 text-body leading-relaxed text-base sm:text-lg">
              No hype, no guarantees — here are the factors that put Dholera on India's investment map.
            </p>
          </Reveal>
        </div>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {GUIDE_FACTORS.map((f, i) => (
            <Reveal key={f.title} delay={0.06 * i} className="bg-white border border-border rounded-sm p-7 hover:shadow-gold-glow transition-shadow duration-300">
              <span className="font-mono text-gold-dark text-sm">0{i + 1}</span>
              <h3 className="mt-3 font-serif text-2xl text-navy font-semibold leading-snug">{f.title}</h3>
              <p className="mt-2 text-body text-sm leading-relaxed">{f.body}</p>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1} className="mt-20">
          <div className="flex items-center gap-3">
            <ShieldCheck className="w-5 h-5 text-gold-dark" />
            <h3 className="font-serif text-3xl text-navy font-semibold">How Paras Real Estate Assists You</h3>
          </div>
        </Reveal>
        <div className="mt-8 grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {GUIDE_STEPS.map((s, i) => (
            <Reveal key={s.step} delay={0.08 * i} className="relative bg-navy rounded-sm p-7 overflow-hidden group">
              <span className="absolute -top-3 -right-1 font-serif text-8xl text-white/5 group-hover:text-gold/10 transition-colors duration-500">{s.step}</span>
              <span className="font-mono text-gold text-xs tracking-[0.2em]">STEP {s.step}</span>
              <h4 className="mt-3 font-serif text-xl text-white font-semibold">{s.title}</h4>
              <p className="mt-2 text-white/65 text-sm leading-relaxed">{s.body}</p>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.15} className="mt-14 bg-white border-l-4 border-gold shadow-card p-7 sm:p-8 rounded-sm flex gap-4">
          <AlertTriangle className="w-6 h-6 text-gold-dark shrink-0 mt-0.5" />
          <div>
            <h4 className="font-semibold text-navy text-sm uppercase tracking-[0.14em]">Important Disclaimer</h4>
            <p className="mt-2 text-body text-sm leading-relaxed">{INVESTMENT_DISCLAIMER}</p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
